import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from "redux";
import { withLocalize, LocalizeContextProps, Translate } from "react-localize-redux";
import bindAllOfThis from 'src/utils/BindThisHelper';
import { Row, Col } from "antd";
import DialogBox from "src/components/mission/DialogBox";
import { MissionState } from "src/redux/CheckpointReducer";
import { UserState } from "src/redux/UserReducer";
import { Grades } from "src/constants/Grades";
import { Planets } from "src/constants/Planets";
import { ReduxStoreModel } from "src/redux/ReduxModel";
import AudioPlayer from "src/components/common/AudioPlayer";
import AudioTranslations from "src/constants/AudioTranslations";
import Routes from 'src/core/Routes';
import CheckpointAction, { KnownCheckpointStates } from "src/redux/CheckpointActions";
import { PageProps } from "src/models/common/ComponentProps";

interface SpaceStationReturnProps extends PageProps<{}>, LocalizeContextProps {
    Mission: MissionState;
    User: UserState;
    updateFreshness: (request: KnownCheckpointStates) => void;
}

class SpaceStationReturn extends React.Component<SpaceStationReturnProps> {
    constructor(props: SpaceStationReturnProps) {
        super(props);
        bindAllOfThis(this, SpaceStationReturn.prototype);
    }

    onNext() {
        this.props.history.push(Routes.STUDENT_PLANET);
    }

    componentDidMount() {
        this.props.updateFreshness("not-fresh");
        document.addEventListener("keydown", this.handleKeyPress, false);
    }

    componentWillUnmount() {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    }

    handleKeyPress(event): void {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.onNext();
            }
        }
    }
    hasNextButton(): boolean {
        return true;
    }
    hasBackButton(): boolean {
        return false;
    }

    render() {
        let currentGrade = Grades.FindById(this.props.User.gradeId);
        let currentPlanet = Planets.FindById(this.props.Mission.current.planetId);
        let audioTrans = AudioTranslations.FindByKeyAndLanguage("student.welcomeBack.body", this.props.activeLanguage.code);

        return <Row>
            <AudioPlayer
                audioURL={audioTrans.url}
                isPlaying={true}/>
            <Col className="dialog-content" xs={{ span: 22, push: 1 }} md={{ span: 16 }} xl={14}>
                <Row>
                    <DialogBox
                        currentGrade={currentGrade}
                        currentPlanet={currentPlanet}
                        buttonNextType={this.hasNextButton() ? "arrow" : "none"}
                        buttonBackType={this.hasBackButton() ? "arrow" : "none"}
                        onNext={this.onNext}>
                        <h2><Translate id="student.welcomeBack.header" /></h2>
                        <p><Translate id="student.welcomeBack.body" /></p>
                    </DialogBox>
                </Row>
            </Col>
            <Col xs={23} md={{ span: 7, push: 1 }} xl={9}>
                <Row type="flex" justify="space-between">
                    <Col xs={{ span: 20, push: 2 }} lg={{ span: 21, push: 1 }}>
                        <img className="station-commander" alt={`Commander ${currentGrade.commander}`} src={currentGrade.commanderPath} height="100%" width="100%" />
                    </Col>
                </Row>
            </Col>
        </Row>;
    }
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
    return {
        updateFreshness: (request: KnownCheckpointStates) => CheckpointAction.SetFreshnessStatus(dispatch, request)
    };
}

function mapStateToProps(state: ReduxStoreModel) {
    return {
        Mission: state.Mission,
        User: state.User
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(SpaceStationReturn));



// WEBPACK FOOTER //
// ./src/pages/student/scenes/SpaceStationReturn.tsx